import type { ReactNode } from 'react';

type Props = {
  children: ReactNode;
};

// The header action-button column shared by the Users, Roles, and ACLs pages. Pinned to the
// top-right corner (self-start, so it stays put as the left column grows taller) with a fixed
// gap between buttons; items-stretch makes every button share the widest one's width, so the
// stacked actions render the same size. Owns the layout so the three pages can't drift.
export default function ActionColumn({ children }: Props) {
  return <div className="flex flex-col items-stretch gap-6 ml-auto self-start">{children}</div>;
}
